import { useContext } from "react";

import { QuickFiltersContext } from "./quick-filters-provider";

export const useQuickFilters = () => {
  const context = useContext(QuickFiltersContext);

  if (!context) {
    throw new Error(
      "useQuickFilters must be used within a QuickFiltersContext",
    );
  }

  return context;
};
